import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import PaymentGatewayListing from '@/modules/bank/components/CreatePaymentGateway/components/CreatePaymentGatewayListing'

function CreatePaymentGatewayPage() {
	return (
		<PageContainer>
			<PaymentGatewayListing />
		</PageContainer>
	)
}

const GuardedCreatePaymentGatewayPage = withUserPermission(
	CreatePaymentGatewayPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.MANAGE_BANK_ACCOUNT],
	},
)

export default GuardedCreatePaymentGatewayPage
